export default '1.10.2';



// WEBPACK FOOTER //
// ./src/lib/version.js